<template>
  <v-container v-if="item.type === 'variable'" fluid class="mt-2">
    <v-progress-linear indeterminate color="blue" v-if="loading"></v-progress-linear>
    <v-row v-for="(v, idx) in descrizioneVariazioni" :key="idx">
      <template v-if="v.ubisell">
        <v-col cols="3"><span class="font-weight-bold mr-2">eCommerce:</span>{{ v.descrizione }}</v-col>
        <v-col cols="4">
          <span class="font-weight-bold mr-2">Gestionale:</span>{{ v.ubisell._id + ' - ' + v.ubisell.descrizione + ' ' +
            getVarianti(v.ubisell) }}
        </v-col>
        <v-col cols="2"><v-btn color="blue darken-1" text @click="eliminaAssociazioneProdotto(v.ubisell._id)">Elimina
            associazione</v-btn></v-col>
      </template>
      <template v-else>
        <v-col cols="3"><span class="font-weight-bold mr-2">eCommerce:</span>{{ v.descrizione }}</v-col>
        <v-col cols="4">
          <component :is="'pProdotto'" :item="itemCodice(item)" :index="idx" :suTable="true"
            @change="componentValueChange" />
        </v-col>
        <v-col cols="2"><v-btn color="blue darken-1" text @click="associaProdotto(v, idx)">Associa</v-btn></v-col>
      </template>
    </v-row>
  </v-container>
  <v-container v-else fluid class="mt-2">
    <v-progress-linear indeterminate color="blue" v-if="loading"></v-progress-linear>
    <v-row v-if="trigger && item.ubisell">
      <v-col cols="3"><span class="font-weight-bold mr-2">eCommerce:</span>{{ descrizioneItem }}</v-col>
      <v-col cols="4">
        <span class="font-weight-bold mr-2">Gestionale:</span>{{ item.ubisell._id + ' - ' + item.ubisell.descrizione +
          ''
          + getVarianti(item.ubisell) }}
      </v-col>
      <v-col cols="2"><v-btn color="blue darken-1" text @click="eliminaAssociazioneProdotto(item.ubisell._id)">Elimina
          associazione</v-btn></v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="3"><span class="font-weight-bold mr-2">eCommerce:</span>{{ descrizioneItem }}</v-col>
      <v-col cols="4">
        <component :is="'pProdotto'" :item="itemCodice(item)" :suTable="true" @change="componentValueChange" />
      </v-col>
      <v-col cols="2"><v-btn color="blue darken-1" text @click="associaProdotto()">Associa</v-btn></v-col>
    </v-row>
  </v-container>
</template>
<script>
  import _ from 'lodash'
  import eCommerce from '@/services/eCommerceService'
  import prodotti from '@/services/prodottiService.js'
  import pProdotto from './prodotto'

  export default {
    components: {
      pProdotto
    },
    props: {
      item: Object,
      prodottiAbilitatiECommerce: Array,
      trigger: Number
    },
    data: () => ({
      descrizioneVariazioni: [],
      descrizioneItem: '',
      loading: false,
      debounceSearch: null,
      searchProdotto: '',
      prodotto: null,
      arProdotto: [],
      triggerRefresh: 1,
      entries: [],
      prefisso: ''
    }),
    watch: {
      async trigger() {
        await this.refresh()
      }
    },
    async mounted() {
      await this.refresh()
    },
    methods: {
      async refresh() {
        this.loading = true
        this.descrizioneVariazioni = await this.getDescrizioneVariazione(this.item)
        this.descrizioneItem = this.getDescrizioneItem(this.item)
        this.loading = false
      },
      getVarianti(item, removeFirstElement) {
        const varianti = _.get(item, removeFirstElement ? 'variante1.descrizione' : 'varianti.variante1.descrizione', '') + ' ' + _.get(item, removeFirstElement ? 'variante2.descrizione' : 'varianti.variante2.descrizione', '')
        return varianti.trim()
      },
      itemCodice(item, onlyValue) {
        if (onlyValue) {
          return _.get(item, 'prodotto.codice', '')
        }
        return {
          "model": "prodotto.codice",
          "valueField": "prodotto.codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "prodotto.descrizione",
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          "cercaEsterno": true,
          "usaScalaTaglie": _.get(item, 'usaScalaTaglie', ''),
          value: _.get(item, 'prodotto.codice', '')
        }
      },
      async componentValueChange(data) {
        const { value, index, item } = data
        if (index !== undefined) {
          this.arProdotto[index] = item
        } else {
          this.prodotto = item
        }
      },
      onchange(prodotto) {
        this.prodotto = prodotto
      },
      onchangeAr(prodotto, idx) {
        this.arProdotto[idx] = prodotto
      },
      async associaProdotto(v, idx) {
        let ubisellProdotto = v ? this.arProdotto[idx] : this.prodotto
        let eCommerceProdotto = v ? v.infoP : this.item
        let prodotto = await prodotti.getProdotto(ubisellProdotto.id)
        prodotto.eCommerce = await eCommerce.mapInfoProdotto(eCommerceProdotto)
        await prodotti.aggiornaProdotto(prodotto)
        this.$emit('aggiorna')
      },
      async eliminaAssociazioneProdotto(id) {
        if (confirm('Confermi eliminazione associazione prodotto ?')) {
          let prodotto = await prodotti.getProdotto(id)
          prodotto.eCommerce = null
          await prodotti.aggiornaProdotto(prodotto)
          await this.$nextTick()
          this.$emit('aggiorna')
        }
      },
      async getDescrizioneVariazione(item, vv) {
        const de = []
        for (let vv of item.variations) {
          const infoP = await eCommerce.getInfoProdotto(vv, true)
          const tagliaOpt = infoP.attributes.find(x => x.name === this.nomeAttributoTaglia)
          const tagliaDescrizione = tagliaOpt ? tagliaOpt.option : ''
          const coloreOpt = infoP.attributes.find(x => x.name === this.nomeAttributoColore)
          const coloreDescrizione = coloreOpt ? coloreOpt.option : ''
          let peC = this.prodottiAbilitatiECommerce.find(x => String(x.eCommerce.id) === String(infoP.id))
          de.push({
            descrizione: `${item.id} - ${infoP.name || item.name} ${tagliaDescrizione} ${coloreDescrizione}`,
            id: item.id,
            infoP: infoP,
            ubisell: peC
          })
        }
        return de
      },
      getDescrizioneItem(item) {
        return `${item.id} - ${item.name}`
      }
    }
  }
</script>
